/**
 * Product Carousel & Gallery Manager
 * Requires jQuery & Slick Carousel
 */
document.addEventListener('DOMContentLoaded', function () {
    const mainContainer = document.querySelector('.main-image-container');
    const thumbnailContainer = document.querySelector('.carousel-thumbnails');

    /**
    * Minimum combined pixel width needed to lay the thumbnail column and
    * the main image out side-by-side (roughly: the 80px thumbnail column
    * + a comfortable minimum for the main image + the flex gap between
    * them). Below this, the gallery lays out as a horizontal thumbnail
    * strip docked under the main image instead. Tune this single number
    * to adjust the layout switch point for both sites.
    */
    const MIN_SIDE_BY_SIDE_WIDTH = 400;

    /**
     * Resolves the element whose width decides the gallery's layout.
     * .product-carousel/.product-main-image are not it - they're just the
     * two wrappers being laid out. Host pages mark the real layout
     * container (the ancestor that actually constrains how much room the
     * gallery has, e.g. a page column or grid cell) with
     * data-image-viewer-container. Falls back to the immediate parent so
     * this still degrades gracefully on a page that hasn't added it.
     */
    function resolveLayoutContainer() {
        const carousel = document.querySelector('.product-carousel');
        if (!carousel) {
            return null;
        }
        return carousel.closest('[data-image-viewer-container]') || carousel.parentElement;
    }

    function shouldUseHorizontalCarousel() {
        const container = resolveLayoutContainer();
        if (!container) {
            return false;
        }
        return container.getBoundingClientRect().width < MIN_SIDE_BY_SIDE_WIDTH;
    }



    function initImageCarousel() {
        var $thumbs = $('.carousel-thumbnails');
        if ($thumbs.hasClass('slick-initialized')) {
            $thumbs.slick('unslick');
        }
        const horizontal = shouldUseHorizontalCarousel();
        const layoutContainer = resolveLayoutContainer();
        if (layoutContainer) {
            layoutContainer.classList.toggle('image-viewer--horizontal', horizontal);
        }

        $('.carousel-thumbnails').slick({
            //vertical: true,
            //verticalSwiping: true,
            vertical: !horizontal,
            verticalSwiping: !horizontal,
            slidesToShow: 5,
            slidesToScroll: 4,
            infinite: false,
            arrows: true,
            dots: false,
            focusOnSelect: false,
            //prevArrow: '<button type="button" class="slick-prev slick-arrow-vertical"></button>',
            //nextArrow: '<button type="button" class="slick-next slick-arrow-vertical"></button>',
            prevArrow: horizontal
                ? '<button type="button" class="slick-prev slick-arrow-horizontal"></button>'
                : '<button type="button" class="slick-prev slick-arrow-vertical"></button>',
            nextArrow: horizontal
                ? '<button type="button" class="slick-next slick-arrow-horizontal"></button>'
                : '<button type="button" class="slick-next slick-arrow-vertical"></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    infinite: false,
                    focusOnSelect: false,
                    arrows: true,
                    centerMode: false,
                    variableWidth: true,
                    prevArrow: '<button type="button" class="slick-prev slick-arrow-horizontal"></button>',
                    nextArrow: '<button type="button" class="slick-next slick-arrow-horizontal"></button>'
                }
            }]
        });
    }

    // Highlights the given thumbnail and scrolls its carousel page into view.
    function setActiveThumbnail(clickedThumbImg) {
        //function thumbnail_onClick(clickedThumbImg) {
        const slideIndex = clickedThumbImg.getAttribute('data-slide-index');

        // Scroll the carousel so the newly-active thumbnail's page is
        // actually visible - focusOnSelect is off below, so Slick never
        // does this on its own when we drive the active state manually
        // (including when this fires from the lightbox-close sync, which
        // can land on a slide several pages away from what's currently in
        // view). This must run BEFORE the manual 'slick-current' assignment
        // below: slickGoTo() manages its own '.slick-current'/'.slick-active'
        // classes as part of navigating, snapping to whatever slide starts
        // the target page (per slidesToScroll) rather than the exact index
        // requested, so doing it first and overriding after guarantees our
        // highlight wins instead of Slick's.
        if (slideIndex !== null && slideIndex !== '') {
            $('.carousel-thumbnails').slick('slickGoTo', parseInt(slideIndex, 10));
        }

        // Remove 'slick-current' class from all carousel thumbnail slides
        const thumbnailSlides = document.querySelectorAll('.carousel-thumbnails .slick-slide');
        thumbnailSlides.forEach(slide => slide.classList.remove('slick-current'));

        // Add 'slick-current' class to the closest parent slide
        const closestSlide = clickedThumbImg.closest('.slick-slide');
        if (closestSlide) {
            closestSlide.classList.add('slick-current');
        }
    }

    /**
     * Renders the given thumbnail's media into the main image/video area.
     * @param {Element} clickedThumbImg
     * @param {?object} [videoState] - when resuming a video handed off from
     *   the lightbox (see the 'sync-main-view' listener below), the exact
     *   {currentTime, paused, userSetMuted} to resume from instead of
     *   starting over from the beginning.
     */
    function showMediaInMainArea(clickedThumbImg, videoState) {
        const slideIndex = clickedThumbImg.getAttribute('data-slide-index');
        const mediaType = clickedThumbImg.getAttribute('data-media-type');

        // Tracks what's actually rendered here right now, independent of
        // '.slick-current' (which, for videos, gets updated on click before
        // this function is even called - see thumbnail_onClick). Read by
        // photoswipe-viewer.js's _getActiveMainIndex() to decide whether a
        // lightbox-close sync is a genuine change or a no-op.
        mainContainer.dataset.activeSlideIndex = slideIndex;

        if (mediaType === 'video' || mediaType === 'external_video') {
            // get the Liquid's video HTML
            const videoHtml = clickedThumbImg.getAttribute('data-video-html');
            mainContainer.innerHTML = videoHtml;

            // set the video attributes
            const video = mainContainer.querySelector('video');
            if (video) {
                //video.autoplay = true;
                video.preload = 'metadata';
                video.style.width = '100%';
                video.style.height = 'auto';
                video.style.display = 'block';

                if (videoState) {
                    // Resume exactly where the lightbox left off, instead of
                    // the <video autoplay> markup restarting it from 0.
                    video.removeAttribute('autoplay');
                    video.autoplay = false;
                    video.muted = !!videoState.userSetMuted;
                    video.addEventListener('loadedmetadata', function onMeta() {
                        video.removeEventListener('loadedmetadata', onMeta);
                        video.currentTime = videoState.currentTime || 0;
                        if (!videoState.paused) {
                            video.play().catch(() => { /* ignore - controls remain available */ });
                        }
                    });
                } else {
                    video.autoplay = true;
                }

                // checking is mobile or other device 
                const isMobile = window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

                if (isMobile) {
                    // removed the autoplay
                    video.removeAttribute('autoplay');
                    video.autoplay = false;

                    // set the poster picture size
                    video.style.minWidth = '100%';
                    video.style.minHeight = '200px';
                    video.setAttribute('poster', video.querySelector('img')?.src || '');

                    const posterImg = video.querySelector('img');
                    if (posterImg) {
                        posterImg.style.width = '100%';
                        posterImg.style.height = 'auto';
                        posterImg.style.objectFit = 'cover';
                    }
                }
            }
        }
        else {
            // Display Standard Image
            const imageSrc = clickedThumbImg.getAttribute('data-main-image');
            const fullImageSrc = clickedThumbImg.getAttribute('data-full-image');
            

            mainContainer.innerHTML = `
				  <div class="main-slide-item" data-slide-index="0" style="display: block;">
					<a class="prlightbox" href="#" data-img="${fullImageSrc}" data-size="1900x1900">
					  <img class="main-product-image" src="${imageSrc}" alt="Product image" 
						   data-full-image="${fullImageSrc}" data-media-type="image" 
						   data-slide-index="${slideIndex}" style="width:100%">
					</a>
				  </div>
				`;

            // Trigger PhotoSwipe re-bind event if present
            setTimeout(() => {
                if (typeof $ !== 'undefined') {
                    $(document).trigger('rebind-photoswipe');
                }
            }, 50);
        }
    }

    function thumbnail_onClick(clickedThumbImg) {
        setActiveThumbnail(clickedThumbImg);

        // Video thumbnails are also .prlightbox triggers (see
        // thumbnail-video-template in ImageViewer.ascx), so a real click on
        // one ALSO opens the PhotoSwipe lightbox for this same event. Don't
        // additionally swap/autoplay the main-area video here too, or the
        // lightbox's copy and this one both play at once, with sound,
        // simultaneously. The lightbox owns playback while it's open; the
        // main-area video gets (re)populated - resuming from exactly where
        // the lightbox left off - once it closes, via the 'sync-main-view'
        // listener below.
        const mediaType = clickedThumbImg.getAttribute('data-media-type');
        const opensLightbox = (mediaType === 'video' || mediaType === 'external_video')
            && clickedThumbImg.closest('.prlightbox');

        if (opensLightbox) {
            const existingVideo = mainContainer.querySelector('video');
            if (existingVideo && !existingVideo.paused) {
                existingVideo.pause();
            }
            return;
        }

        showMediaInMainArea(clickedThumbImg);
    }

    initImageCarousel();
    thumbnailContainer.addEventListener('click', function (event) {
        // Find if the clicked element or any of its parents match the target selector
        const clickedThumbImg = event.target.closest('.thumbnail-item img');
        
        // If the click happened inside a .thumbnail-item img
        if (clickedThumbImg && thumbnailContainer.contains(clickedThumbImg)) {
            thumbnail_onClick(clickedThumbImg);
        }
    });

    // Fired by photoswipe-viewer.js when the lightbox closes, so the
    // on-page carousel/main image reflect whichever slide was open -
    // including resuming video playback from its exact position/sound
    // state rather than restarting it.
    $(document).on('sync-main-view', function (event, data) {
        setActiveThumbnail(data.thumbImg);
        showMediaInMainArea(data.thumbImg, data.videoState);
    });

    window.ProductImageViewer = {
        showMediaInMainArea: showMediaInMainArea,
        setActiveThumbnail: setActiveThumbnail,
        initImageCarousel: initImageCarousel,
        unslickCarousel: function () {
            var $thumbs = $('.carousel-thumbnails');
            if ($thumbs.hasClass('slick-initialized')) {
                $thumbs.slick('unslick');
            }
        }
    };

    $(document).trigger('product-image-ready');
});